module.exports = "<div class=\"wrapper\">\n  <div class=\"left-side\"></div>\n\n  <div class=\"center\">\n    <navigation-component></navigation-component>\n\n    <simple-notifications [options]=\"{\n      position: ['top', 'right'],\n      timeOut: 5000,\n      showProgressBar: true,\n      lastOnBottom: true\n    }\"></simple-notifications>\n    <router-outlet></router-outlet>\n  </div>\n\n  <div class=\"right-side\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/app.component.html
// module id = ./src/app/templates/app.component.html
// module chunks = 0